import React from 'react';
import {getUpdatePaymentBanStripLabel} from '../utils/updatePaymentBanUtils';

const UpdatePaymentBanStrip = ({selectedBans, onDetailsClick}) => {
  if (!selectedBans?.length) {
    return null;
  }

  return (
    <div className='update-payment-ban-strip'>
      <div className='update-payment-ban-strip__label'>{getUpdatePaymentBanStripLabel(selectedBans)}</div>
      <button type='button' className='update-payment-ban-strip__details-link' onClick={onDetailsClick}>
        לפרטים
      </button>
    </div>
  );
};

export default UpdatePaymentBanStrip;
